function fn_nl_preload() {
    $("body").removeClass("preload").addClass("loaded");
    setTimeout(function () {
        $("body").removeClass("loaded");
    }, 300);
}